module.exports = __webpack_public_path__ + "img/er.d2057350.svg";